import { Box, Button, IconButton, Modal } from '@mui/material';
import React, { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReactTable } from '@components';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import { MRT_ToggleGlobalFilterButton } from 'material-react-table';
import CreateCounterParty from './Create';
import { apiDeleteCounterParty, deleteCounterParty } from '@store';
import { showToast } from '@utils';

const CounterParty = () => {
    const dispatch = useDispatch();
    const { counterParty, isGetCounterPartyLoading } = useSelector(
        (state) => state.counterParty
    );

    const [openModal, setOpenModal] = useState(false);
    const handleOpenModal = () => {
        setOpenModal(true);
    };
    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const handleDelete = async (counterparty) => {
        if (
            window.confirm('Are you sure you want to delete this counterparty?')
        ) {
            const resp = await dispatch(apiDeleteCounterParty(counterparty));
            if (resp?.meta?.requestStatus === 'fulfilled') {
                dispatch(deleteCounterParty(counterparty));
                showToast('info', 'Counterparty deleted successfully');
            } else if (resp?.meta?.requestStatus === 'rejected') {
                showToast('error', resp.payload);
            }
        }
    };

    const columns = useMemo(
        () => [
            {
                header: '#',
                id: 'uuid',
                accessorFn: ({ uuid }) => uuid || '',
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>
            },
            {
                header: 'Name',
                id: 'name',
                accessorFn: ({ name }) => name || '',
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>
            },
            {
                header: 'Country',
                id: 'country',
                accessorFn: ({ country }) => country || '',
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>
            },
            {
                header: 'Phone',
                id: 'phone',
                accessorFn: ({ phone }) => phone || '',
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>
            },
            {
                header: 'Location',
                id: 'location',
                accessorFn: ({ location }) => location || '',
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>
            }
        ],
        []
    );

    const actionsMenu = useMemo(
        () =>
            ({ row }) => [
                <Button
                    variant="outlined"
                    color="error"
                    sx={{
                        p: 0,
                        m: 0,
                        borderColor: 'brown',
                        color: 'brown',
                        fontSize: '13px',
                        '&:hover': {
                            borderColor: 'brown',
                            color: 'white',
                            backgroundColor: 'brown'
                        }
                    }}
                    onClick={() => handleDelete(row.original?.uuid)}
                >
                    Delete
                </Button>
            ],
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    return (
        <Box>
            <Modal open={openModal} onClose={handleCloseModal}>
                <CreateCounterParty handleClose={handleCloseModal} />
            </Modal>
            <ReactTable
                renderToolbarInternalActions={({ table }) => (
                    <div onMouseDown={(e) => e.stopPropagation()}>
                        <MRT_ToggleGlobalFilterButton table={table} />
                        <IconButton
                            onClick={handleOpenModal}
                            title="Create Counterparty"
                        >
                            <AddBoxOutlinedIcon />
                        </IconButton>
                    </div>
                )}
                headerText={'Counterparty'}
                columns={columns}
                data={counterParty || []}
                actions={actionsMenu}
                isLoading={isGetCounterPartyLoading}
            />
        </Box>
    );
};

export default CounterParty;
